import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<void, 'checked'>()(
  (theme, _params, classes) => ({
    container: {
      paddingTop: theme.spacing(5),
      maxWidth: '700px',
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    subHeading: {
      color: theme.palette.text.secondary,
      fontSize: '18px',
      fontWeight: 600,
      marginRight: theme.spacing(1.125),
    },
    infoIcon: {
      color: theme.palette.icon.main,
      marginTop: theme.spacing(0.75),
      '&.MuiSvgIcon-root': {
        height: '16px',
        width: '16px',
      },
    },
    companyDetailSubHead: {
      marginBottom: theme.spacing(2),
    },
    subHeadingContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    title: {
      fontSize: 18,
      fontWeight: 500,
      letterSpacing: 0.5,
    },
    installmentContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(3),
      justifyContent: 'space-between',
    },
    installmentItem: {
      width: '100%',
      maxWidth: '320px',
    },
    inputContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(2),
      flexGrow: 4,
    },
    installmentAction: {
      width: '50px',
    },
    radio: {
      [`&.${classes.checked}`]: {
        color: theme.palette.success.main,
      },
    },
    checked: {},
  })
)
